import launchCityConfig from './launchCities.json';

export interface LaunchCity {
  name: string;
  latitude: number;
  longitude: number;
}

export const LAUNCH_CITIES: LaunchCity[] = launchCityConfig.launchCities;
export const COACH_RECRUITMENT_CITIES: LaunchCity[] = launchCityConfig.coachRecruitmentCities;
export const LAUNCH_CITY_RADIUS_MILES = launchCityConfig.launchCityRadiusMiles;
